/* Lux Signage Co. shared forms, contact menu, attribution, and safe event tracking. */
(function () {
  'use strict';

  var STORAGE_KEY = 'lux_attribution_v1';
  var RESPONSE_KEY = 'lux_form_response_';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var activeContext = {};
  var lastModalFocus = null;

  function onReady(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  }

  function createEventId(prefix) {
    return String(prefix || 'lux') + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  }

  function storageGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (error) { return null; }
  }

  function storageSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (error) {}
  }

  function currentParams() {
    try { return new URL(window.location.href).searchParams; } catch (error) { return null; }
  }

  function loadAttribution() {
    var saved = {};
    try { saved = JSON.parse(storageGet(STORAGE_KEY) || '{}') || {}; } catch (error) {}
    var params = currentParams();
    UTM_KEYS.forEach(function (key) {
      var value = params ? params.get(key) : '';
      if (value) saved[key] = value;
      else if (typeof saved[key] !== 'string') saved[key] = '';
    });
    if (!saved.landing_page) saved.landing_page = window.location.href;
    if (!saved.referrer) saved.referrer = document.referrer || '';
    storageSet(STORAGE_KEY, JSON.stringify(saved));
    return saved;
  }

  function analyticsAllowed() {
    try {
      if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
        return Shopify.customerPrivacy.analyticsProcessingAllowed();
      }
    } catch (error) {}
    return true;
  }

  function cleanContext(context) {
    context = context || {};
    return {
      form_type: String(context.form_type || ''),
      form_context: String(context.form_context || ''),
      product_handle: String(context.product_handle || ''),
      product_title: String(context.product_title || ''),
      sign_style: String(context.sign_style || ''),
      variant_id: String(context.variant_id || ''),
      trigger_location: String(context.trigger_location || ''),
      resource_key: String(context.resource_key || ''),
      gallery_category: String(context.gallery_category || ''),
      result_count: typeof context.result_count === 'number' ? context.result_count : undefined,
      query_length: typeof context.query_length === 'number' ? context.query_length : undefined
    };
  }

  function safeAnalyticsValue(value, maxLength) {
    var text = String(value || '').trim();
    if (!text) return '';
    if (/@/.test(text) || /(?:\+?\d[\s().-]*){7,}/.test(text)) return '';
    return text.slice(0, maxLength || 120);
  }

  function track(eventName, context, eventId) {
    var safe = cleanContext(context);
    var attribution = loadAttribution();
    var id = eventId || createEventId(eventName);
    var payload = {
      event: eventName,
      lux_event_id: id,
      lux_form_type: safe.form_type,
      lux_form_context: safe.form_context,
      lux_product_handle: safe.product_handle,
      lux_product_title: safe.product_title,
      lux_sign_style: safe.sign_style,
      lux_variant_id: safe.variant_id,
      lux_trigger_location: safe.trigger_location,
      lux_resource_key: safe.resource_key,
      lux_gallery_category: safe.gallery_category,
      lux_result_count: safe.result_count,
      lux_query_length: safe.query_length,
      lux_source_page: window.location.pathname,
      page_url: window.location.origin + window.location.pathname,
      page_title: document.title,
      utm_source: safeAnalyticsValue(attribution.utm_source, 100),
      utm_medium: safeAnalyticsValue(attribution.utm_medium, 100),
      utm_campaign: safeAnalyticsValue(attribution.utm_campaign, 100),
      utm_content: safeAnalyticsValue(attribution.utm_content, 100),
      utm_term: safeAnalyticsValue(attribution.utm_term, 100)
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    try { window.dispatchEvent(new CustomEvent('lux:analytics', { detail: payload })); } catch (error) {}

    if (analyticsAllowed() && typeof window.fbq === 'function') {
      var metaData = {
        content_category: safe.form_type || eventName,
        content_name: safe.sign_style || safe.product_title || eventName
      };
      if (/_form_submit$/.test(eventName)) window.fbq('track', 'Lead', metaData, { eventID: id });
      else window.fbq('trackCustom', eventName, metaData, { eventID: id });
    }
    return id;
  }

  function triggerLocation(element) {
    if (!element) return '';
    if (element.getAttribute('data-lux-trigger-location')) return element.getAttribute('data-lux-trigger-location');
    var section = element.closest('[id]');
    return section ? section.id : (element.id || element.className || 'unknown');
  }

  function closestFromEvent(event, selector) {
    var target = event && event.target;
    if (!target) return null;
    if (target.nodeType !== 1) target = target.parentElement;
    return target && typeof target.closest === 'function' ? target.closest(selector) : null;
  }

  function contextFromTrigger(element, formType) {
    element = element || document.body;
    var productRoot = element.closest('[data-product-handle], [data-lux-product-handle]');
    var dataset = element.dataset || {};
    var rootDataset = productRoot && productRoot.dataset ? productRoot.dataset : {};
    var bodyDataset = document.body && document.body.dataset ? document.body.dataset : {};
    var selectedVariant = document.querySelector('form[action*="/cart/add"] [name="id"], [data-product-form] [name="id"]');
    return {
      form_type: formType,
      form_context: 'popup',
      product_handle: dataset.luxProductHandle || dataset.productHandle || rootDataset.luxProductHandle || rootDataset.productHandle || bodyDataset.luxProductHandle || '',
      product_title: dataset.luxProductTitle || dataset.productTitle || rootDataset.luxProductTitle || rootDataset.productTitle || bodyDataset.luxProductTitle || '',
      sign_style: dataset.luxStyle || dataset.signStyle || '',
      variant_id: dataset.luxVariantId || dataset.variantId || rootDataset.luxVariantId || rootDataset.variantId || (selectedVariant ? selectedVariant.value : '') || bodyDataset.luxVariantId || '',
      trigger_location: triggerLocation(element)
    };
  }

  function formTypeFromTrigger(element) {
    if (!element) return '';
    var explicit = element.getAttribute('data-lux-open');
    if (explicit === 'quote' || explicit === 'partner') return explicit;
    if (element.hasAttribute('data-lux-open-quote')) return 'quote';
    if (element.hasAttribute('data-lux-open-partner')) return 'partner';
    var href = element.getAttribute('href') || '';
    if (href === '#lux-quote') return 'quote';
    if (href === '#lux-partner') return 'partner';
    return '';
  }

  function fillFields(form, context, eventId) {
    if (!form) return;
    var attribution = loadAttribution();
    var tracking = {
      event_id: eventId || createEventId('lux_' + (context.form_type || 'form')),
      source_page: window.location.pathname,
      page_url: window.location.href,
      page_title: document.title,
      referrer: attribution.referrer || document.referrer || '',
      utm_source: attribution.utm_source || '',
      utm_medium: attribution.utm_medium || '',
      utm_campaign: attribution.utm_campaign || '',
      utm_content: attribution.utm_content || '',
      utm_term: attribution.utm_term || ''
    };
    var safe = cleanContext(context);
    form.querySelectorAll('[data-lux-track-field]').forEach(function (field) {
      var key = field.getAttribute('data-lux-track-field');
      field.value = tracking[key] || '';
    });
    form.querySelectorAll('[data-lux-context-field]').forEach(function (field) {
      var key = field.getAttribute('data-lux-context-field');
      field.value = safe[key] || '';
    });
    form.dataset.luxEventId = tracking.event_id;
    form.dataset.luxContext = JSON.stringify(safe);
  }

  function selectQuoteStyle(style) {
    var select = document.getElementById('lux-quote-style');
    if (!select || !style) return;
    var match = Array.prototype.some.call(select.options, function (option) {
      if (option.value.toLowerCase() === String(style).toLowerCase()) {
        select.value = option.value;
        return true;
      }
      return false;
    });
    if (!match) {
      var option = document.createElement('option');
      option.value = style;
      option.textContent = style;
      select.appendChild(option);
      select.value = style;
    }
  }

  function modalElements() {
    var modal = document.getElementById('lux-global-form-modal');
    return {
      modal: modal,
      overlay: modal ? modal.querySelector('.lux-modal-overlay') : null,
      shell: modal ? modal.querySelector('.lux-modal-shell') : null,
      panels: modal ? modal.querySelectorAll('[data-lux-panel]') : []
    };
  }

  function prepareModal() {
    var parts = modalElements();
    var modal = parts.modal;
    if (!modal || modal.dataset.luxPrepared === 'true') return parts;
    modal.dataset.luxPrepared = 'true';
    var wrappers = [];
    var node = modal.parentElement;
    while (node && node !== document.body) {
      if (node.matches && node.matches('.shopify-section, [id^="shopify-section"], .custom-liquid, .section, .footer-block, .footer-block__details-content')) wrappers.push(node);
      node = node.parentElement;
    }
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    wrappers.forEach(function (wrapper) {
      if (!wrapper.querySelector('#lux-site-footer')) wrapper.classList.add('lux-hidden-popup-section');
    });
    modal.setAttribute('aria-hidden', 'true');
    return parts;
  }

  function openModal(formType, opener, shouldTrack) {
    var parts = prepareModal();
    if (!parts.modal) return;
    formType = formType === 'quote' ? 'quote' : 'partner';
    activeContext = contextFromTrigger(opener, formType);
    lastModalFocus = opener || document.activeElement;
    var eventId = createEventId('lux_' + formType);

    Array.prototype.forEach.call(parts.panels, function (panel) {
      panel.hidden = panel.getAttribute('data-lux-panel') !== formType;
    });
    if (parts.shell) {
      parts.shell.scrollTop = 0;
      parts.shell.setAttribute('aria-labelledby', formType === 'quote' ? 'lux-quote-modal-title' : 'lux-partner-modal-title');
    }
    if (formType === 'quote') selectQuoteStyle(activeContext.sign_style);
    var form = parts.modal.querySelector('[data-lux-panel="' + formType + '"] form');
    fillFields(form, activeContext, eventId);
    parts.modal.hidden = false;
    parts.modal.setAttribute('aria-hidden', 'false');
    parts.modal.dataset.luxActiveForm = formType;
    document.body.classList.add('lux-modal-open');
    try { document.dispatchEvent(new CustomEvent('lux:form-open', { detail: { formType: formType } })); } catch (error) {}
    if (shouldTrack !== false) track('lux_' + formType + '_form_open', activeContext, eventId);
    window.setTimeout(function () {
      var first = parts.modal.querySelector('[data-lux-panel="' + formType + '"] input:not([type="hidden"]), [data-lux-panel="' + formType + '"] select, [data-lux-panel="' + formType + '"] textarea');
      if (first) first.focus();
    }, 30);
  }

  function closeModal() {
    var parts = modalElements();
    if (!parts.modal || parts.modal.hidden) return;
    parts.modal.hidden = true;
    parts.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lux-modal-open');
    if (lastModalFocus && typeof lastModalFocus.focus === 'function') lastModalFocus.focus();
  }

  function trapFocus(event, container) {
    if (event.key !== 'Tab' || !container) return;
    var focusable = Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (item) {
      return item.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function bindContactMenu() {
    var header = document.getElementById('lux-trade-header');
    if (!header || header.dataset.luxContactReady === 'true') return;
    var toggle = header.querySelector('[data-lux-contact-toggle]');
    var menu = header.querySelector('#lux-header-contact-menu');
    var actions = header.querySelector('.lux-nav-actions');
    if (!toggle || !menu || !actions) return;
    header.dataset.luxContactReady = 'true';
    function close(returnFocus) {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) toggle.focus();
    }
    toggle.addEventListener('click', function () {
      if (menu.hidden) {
        menu.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        track('lux_contact_menu_open', { trigger_location: 'fixed_header' });
      } else close(false);
    });
    document.addEventListener('click', function (event) {
      if (!menu.hidden && !actions.contains(event.target)) close(true);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) close(true);
    });
    document.addEventListener('lux:form-open', function () { close(false); });
  }

  function formContext(form) {
    var stored = {};
    try { stored = JSON.parse(form.dataset.luxContext || '{}') || {}; } catch (error) {}
    stored.form_type = form.dataset.luxForm || stored.form_type || 'partner';
    stored.form_context = form.dataset.luxFormContext || stored.form_context || 'inline';
    return stored;
  }

  function bindForm(form) {
    if (!form || form.dataset.luxBound === 'true') return;
    form.dataset.luxBound = 'true';
    var type = form.dataset.luxForm || 'partner';
    var context = formContext(form);
    fillFields(form, context, createEventId('lux_' + type));

    function markStarted() {
      if (form.dataset.luxStarted === 'true') return;
      form.dataset.luxStarted = 'true';
      track('lux_' + type + '_form_start', formContext(form), form.dataset.luxEventId);
    }
    form.addEventListener('focusin', function (event) {
      if (event.target.matches('input:not([type="hidden"]), select, textarea')) markStarted();
    });
    form.addEventListener('change', function (event) {
      if (event.target.matches('input[type="file"]') && event.target.files && event.target.files.length) {
        track('lux_quote_file_added', formContext(form), form.dataset.luxEventId);
      }
      if (event.target.matches('[name="contact[Sign Style]"]')) {
        var updatedContext = formContext(form);
        updatedContext.sign_style = event.target.value || '';
        form.dataset.luxContext = JSON.stringify(cleanContext(updatedContext));
        fillFields(form, updatedContext, form.dataset.luxEventId);
      }
    });
    form.addEventListener('invalid', function () {
      if (form.dataset.luxInvalidTracked === 'true') return;
      form.dataset.luxInvalidTracked = 'true';
      track('lux_' + type + '_form_error', formContext(form), form.dataset.luxEventId);
      window.setTimeout(function () { delete form.dataset.luxInvalidTracked; }, 500);
    }, true);
    form.addEventListener('submit', function (event) {
      if (form.dataset.luxSubmitting === 'true') {
        event.preventDefault();
        return;
      }
      var submitter = event.submitter || form.querySelector('[type="submit"]');
      var projectFile = form.querySelector('[data-lux-project-file]');
      var projectFileName = form.querySelector('[data-lux-project-file-name]');
      if (projectFile && projectFileName) projectFileName.value = projectFile.files && projectFile.files[0] ? projectFile.files[0].name : '';
      var eventId = form.dataset.luxEventId || createEventId('lux_' + type);
      fillFields(form, formContext(form), eventId);
      form.dataset.luxSubmitting = 'true';
      storageSet('lux_last_' + type + '_submission', eventId);
      track('lux_' + type + '_form_submit', formContext(form), eventId);
      if (submitter) {
        submitter.disabled = true;
        submitter.setAttribute('aria-busy', 'true');
        submitter.dataset.luxOriginalText = submitter.textContent;
        submitter.textContent = 'Sending...';
      }
    });

    var success = form.querySelector('.lux-form-success');
    var error = form.querySelector('.lux-form-error');
    var response = success ? 'success' : (error ? 'error' : '');
    if (response) {
      var responseId = storageGet('lux_last_' + type + '_submission') || form.dataset.luxEventId || createEventId('lux_' + type);
      var responseToken = RESPONSE_KEY + responseId + '_' + response;
      if (!storageGet(responseToken)) {
        track('lux_' + type + '_form_' + response, formContext(form), responseId);
        storageSet(responseToken, '1');
      }
    }
  }

  function restoreSubmitButtons() {
    document.querySelectorAll('form[data-lux-form]').forEach(function (form) {
      delete form.dataset.luxSubmitting;
      var button = form.querySelector('[type="submit"][data-lux-original-text]');
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = button.dataset.luxOriginalText;
      }
    });
  }

  function bindGlobalEvents() {
    if (document.documentElement.dataset.luxGlobalReady === 'true') return;
    document.documentElement.dataset.luxGlobalReady = 'true';

    document.addEventListener('click', function (event) {
      var opener = closestFromEvent(event, '[data-lux-open], [data-lux-open-quote], [data-lux-open-partner], a[href="#lux-quote"], a[href="#lux-partner"]');
      if (opener) {
        var formType = formTypeFromTrigger(opener);
        if (formType === 'quote' || formType === 'partner') {
          event.preventDefault();
          var context = contextFromTrigger(opener, formType);
          if (formType === 'quote' && (context.product_handle || context.sign_style)) track('lux_product_quote_click', context);
          openModal(formType, opener, true);
          return;
        }
      }
      var close = closestFromEvent(event, '[data-lux-close]');
      var parts = modalElements();
      if (close && parts.modal && parts.modal.contains(close)) {
        event.preventDefault();
        closeModal();
        return;
      }
      if (parts.overlay && event.target === parts.overlay) {
        event.preventDefault();
        closeModal();
        return;
      }
      var contact = closestFromEvent(event, 'a[href^="tel:"], a[href^="mailto:"]');
      if (contact) {
        var isPhone = contact.getAttribute('href').toLowerCase().indexOf('tel:') === 0;
        track(isPhone ? 'lux_contact_phone_click' : 'lux_contact_email_click', { trigger_location: triggerLocation(contact) });
      }
      var choice = closestFromEvent(event, '[data-lux-spec-handle], [data-collection-handle], [data-style-handle]');
      if (choice) {
        track('lux_product_select', {
          product_handle: choice.getAttribute('data-lux-spec-handle') || choice.getAttribute('data-collection-handle') || choice.getAttribute('data-style-handle') || '',
          product_title: (choice.textContent || '').trim().slice(0, 120),
          trigger_location: triggerLocation(choice)
        });
      }
      var resource = closestFromEvent(event, '[data-lux-resource-key]');
      if (resource) track('lux_resource_open', { resource_key: resource.getAttribute('data-lux-resource-key') || '', trigger_location: 'resources' });
      var galleryFilter = closestFromEvent(event, '[data-lux-filter]');
      if (galleryFilter) track('lux_gallery_filter', { gallery_category: galleryFilter.getAttribute('data-lux-filter') || '' });
      var galleryCard = closestFromEvent(event, '[data-lux-gallery-card]');
      if (galleryCard) track('lux_gallery_image_open', { gallery_category: galleryCard.getAttribute('data-category') || '' });
    });

    document.addEventListener('keydown', function (event) {
      var parts = modalElements();
      if (event.key === 'Escape' && parts.modal && !parts.modal.hidden) {
        closeModal();
        return;
      }
      if (parts.modal && !parts.modal.hidden) trapFocus(event, parts.shell);
      var gallery = document.querySelector('[data-lux-gallery-modal].is-open');
      if (gallery) trapFocus(event, gallery);
    });

    var searchTimer = null;
    document.addEventListener('input', function (event) {
      if (!event.target.matches('[data-lux-resource-search]')) return;
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(function () {
        var root = event.target.closest('#lux-resource-center') || document;
        var visible = root.querySelectorAll('.lux-res-item-card:not([hidden])').length;
        track('lux_resource_search', { query_length: event.target.value.trim().length, result_count: visible, trigger_location: 'resources' });
      }, 700);
    });
  }

  function reopenResponseModal() {
    var parts = prepareModal();
    if (!parts.modal) return;
    var response = parts.modal.querySelector('.lux-form-success, .lux-form-error');
    var panel = response ? response.closest('[data-lux-panel]') : null;
    if (panel) openModal(panel.getAttribute('data-lux-panel'), null, false);
  }

  function initialize() {
    loadAttribution();
    bindGlobalEvents();
    bindContactMenu();
    prepareModal();
    var knownForms = [
      ['lux-popup-partner-form', 'partner', 'popup'],
      ['lux-inline-partner-form', 'partner', 'inline'],
      ['lux-popup-quote-form', 'quote', 'popup']
    ];
    knownForms.forEach(function (entry) {
      var form = document.getElementById(entry[0]);
      if (form) {
        form.dataset.luxForm = entry[1];
        form.dataset.luxFormContext = entry[2];
      }
    });
    document.querySelectorAll('form[data-lux-form]').forEach(bindForm);
    reopenResponseModal();
  }

  onReady(initialize);
  window.addEventListener('pageshow', restoreSubmitButtons);
  document.addEventListener('shopify:section:load', function () { window.setTimeout(initialize, 0); });
})();
